import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { TabView, TabPanel } from 'primereact/tabview';
import AutoexcluidosGallery from './../../components/Formularios/AutoexcluidosGallery';
import AutoexcluidosLookup from './../../components/Formularios/AutoexcluidosLookup';
import InformeAsistencia from './../../components/Formularios/InformeAsistencia';
import FormularioAuto from './../../components/Formularios/FormularioAuto';
import BDEmpleados from './../../components/dashboard/BDEmpleados';
import BDAutoexcluidos from './../../components/dashboard/BDAutoexcluidos';

const AutoexcluidosPanel = () => {
  const auth = useAuth();
  const userRole = auth.role || null;
  const [activeIndex, setActiveIndex] = useState(0);
  const [galleryKey, setGalleryKey] = useState(0);
  const navigate = useNavigate();

  return (
    <div id="panelAuto" style={{
      border: '1px solid #000',
      boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
      padding: '5px',
      borderRadius: '5px',
      width: '100%',
      maxWidth: '100%',
      margin: 'auto'
    }}>
      <center>
        <h1 className="botonbordeazul text-white px-5 mx-5 py-3 h1">Panel de Autoexcluidos</h1>
      </center>

      <TabView
        style={{ width: '100%' }}
        activeIndex={activeIndex}
        onTabChange={(e) => setActiveIndex(e.index)}
      >
        <TabPanel header="Buscar">
          <div style={{ padding: '10px' }}>
            <AutoexcluidosLookup />
          </div>
        </TabPanel>

        <TabPanel header="Galería">
          <div style={{ padding: '10px' }}>
            <AutoexcluidosGallery key={galleryKey} />
          </div>
        </TabPanel>

        {(userRole === "admin" || userRole === "adminauto") && (
          <TabPanel header="Informe de Asistencia">
            <div style={{ padding: '10px' }}>
              <InformeAsistencia />
            </div>
          </TabPanel>
        )}

        {(userRole === "admin" || userRole === "adminauto") && (
          <TabPanel header="Alta Autoexcluidos">
            <div style={{ padding: '10px' }}>
              <FormularioAuto
                onSuccess={() => {
                  setActiveIndex(0);
                  setGalleryKey((prev) => prev + 1);
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }}
              />
            </div>
          </TabPanel>
        )}

        <TabPanel header="Empleados">
          <div style={{ padding: '10px' }}>
            <BDEmpleados />
          </div>
        </TabPanel>

        <TabPanel header="BD Autoexcluidos">
          <div style={{ padding: '10px' }}>
           <BDAutoexcluidos />
          </div>
        </TabPanel>
      </TabView>
    </div>
  );
};

export default AutoexcluidosPanel;
